var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
// libs
import React from 'react';
import dayjs from 'dayjs';
// components
import { PerformanceSummary } from '@/components/PerformanceSummary';
import useAccountStore from '@/stores/account';
// defs
import { AdvertiserDimensions } from '@local/typedefs/dist/protos/campaign/AdvertiserMetrics';
// styles
import style from '../../index.module.scss';
// includes
import { getMetricsApi } from '@/includes/api/metrics';
const PerformanceMetrics = ({ campaignId, performanceData, setPerformanceData, setSelectedRange, }) => {
    const getCurrentAccountId = useAccountStore((state) => state.getCurrentAccountId);
    const fetchMetrics = (startDate, endDate, rangeType) => __awaiter(void 0, void 0, void 0, function* () {
        var _a;
        try {
            const accountId = yield getCurrentAccountId();
            const performanceMetricsResult = yield getMetricsApi({
                accountId,
                dimensions: [
                    AdvertiserDimensions.DIMENSION_CAMPAIGN,
                    AdvertiserDimensions.DIMENSION_DAY,
                ],
                campaignIds: [campaignId],
                interval: {
                    startTime: dayjs(startDate).toString(),
                    endTime: dayjs(endDate).toString(),
                },
            });
            if (performanceMetricsResult) {
                setPerformanceData((_a = performanceMetricsResult.metrics) === null || _a === void 0 ? void 0 : _a.metricsOnDimension);
                setSelectedRange({
                    type: rangeType,
                    range: {
                        startTime: startDate.toISOString(),
                        endTime: endDate.toISOString(),
                    },
                });
            }
        }
        catch (err) {
            if (__DEV__) {
                console.log(err);
            }
        }
    });
    return (React.createElement(PerformanceSummary, { className: style.performanceContainer, performanceData: performanceData, fetchMetrics: fetchMetrics, campaignIds: [campaignId] }));
};
export default PerformanceMetrics;
